import type { ParsedPersonalMessage } from '@module/types/centrifuge/messageTypes';
import { isPersonalSupportMessage, type PersonalSupportMessage } from '@module/types/centrifuge/personalMessageTypes';
import type { MessageHandler, MessageHandlerAction, MessageHandlerContext } from '../types';

export class PersonalSupportHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<PersonalSupportMessage>) {}

  canHandle(payload: ParsedPersonalMessage): boolean {
    return isPersonalSupportMessage(payload);
  }

  handle(payload: PersonalSupportMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;
    if (!context.playInfo) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작
    context.setChatMessages((prev) => [...prev, payload]);
  }
}
